/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable radix */
import { saveAs } from 'file-saver'
import { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import { useConfiguracoes } from '../../pages/Configuracoes/useConfiguracoes'
import { usePredictionDetails } from '../../pages/PredictionDetails/usePredictionDetails'
import {
  criaPedido,
  gerarPedidoPdf,
} from '../../services/CriaPedido/getCriaPedido'
import { getConfiguracoesGetInstancia } from '../../services/Configuracoes/getConfiguracoes'
import {
  getMixProdutos,
  getMixRecomendacoes,
} from '../../services/MixService/getMixRecomendacoes'

export const useCriarPedido = () => {
  const {
    clientData,
    produtos,
    deletarItem,
    handleFiltroProduto,
    handleAddProduct,
    handleProdutoFiltrado,
    arrayProdutos,
    produto,
    valueProduct,
    setValueProduct,
    valueProductId,
    setValueProductId,
    productArray,
    dias,
    setDias,
    getBuscaProdutosPedido,
  } = usePredictionDetails()

  const [produtosAdicionados, setProdutosAdicionados] = useState<GetPedido>(
    {} as GetPedido
  )

  // Oportunidades do Mix (PD-0002): categorias recomendadas + produto escolhido -> lista A PARTE,
  // separada dos itens do pedido; sai numa secao propria da mensagem.
  const [oportunidadesCategorias, setOportunidadesCategorias] = useState<
    MixRecomendacaoItemType[]
  >([])
  const [categoriaOportunidade, setCategoriaOportunidade] = useState<string>('')
  const [produtosOportunidade, setProdutosOportunidade] = useState<
    MixProdutoItemType[]
  >([])
  const [produtoOportunidadeId, setProdutoOportunidadeId] = useState<
    number | undefined
  >(undefined)
  const [quantidadeOportunidade, setQuantidadeOportunidade] = useState(1)
  const [oportunidadesAdicionadas, setOportunidadesAdicionadas] = useState<
    MixOportunidadePedidoType[]
  >([])

  const [isLoading, setIsLoading] = useState(true)
  const [isEnviando, setIsEnviando] = useState(false)
  const [isGerandoPdf, setIsGerandoPdf] = useState(false)
  // O campo "Dias" só vale depois do "Aplicar" — é ali que as quantidades da tabela são
  // recalculadas. Sem guardar o valor APLICADO, digitar 60 sem aplicar faria o PDF anunciar
  // "60 dias" sobre quantidades de 30, que é exatamente a contradição que o desenho (corpo com
  // a lista da tela) existe para evitar. '30' é o mesmo default do carregamento inicial.
  const [diasAplicados, setDiasAplicados] = useState('30')
  // Trava sincrona contra duplo envio (o estado isEnviando so atualiza no proximo render).
  const enviandoRef = useRef(false)
  const [showProducts, setShowProducts] = useState(false)
  const [cancelar, setCancelar] = useState(false)
  const [checkedWhatsApp, setCheckedWhatsApp] = useState(false)
  const [checkedEmail, setCheckedEmail] = useState(false)
  const [email, setEmail] = useState<string | undefined>('')
  const [whatsApp, setWhasApp] = useState<string | undefined>('')
  const [clienteId, setClienteId] = useState('')
  const [isInstanciaCarregada, setIsInstanciaCarregada] = useState(false)

  const [instancia, setInstancia] = useState<GetConfiguracoesInstacia>(
    {} as GetConfiguracoesInstacia
  )

  const fetchGetInstancia = async () => {
    setIsLoading(true)
    const result = await getConfiguracoesGetInstancia()
    setIsLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setInstancia(result)
    }
  }

  const criaNovoPedido = async () => {
    if (enviandoRef.current) return
    enviandoRef.current = true
    setIsEnviando(true)
    const predicaoPedidoRequestDTO = {
      email,
      enviarEmail: checkedEmail,
      enviarWhatsApp: checkedWhatsApp,
      numeroWhatsApp: whatsApp,
      produtos: produtosAdicionados.map(item => ({
        id: item.id,
        quantidade: item.quantidade,
      })),
      oportunidades: oportunidadesAdicionadas.map(item => ({
        id: item.id,
        quantidade: item.quantidade,
        categoria: item.categoria,
      })),
    }
    const result = await criaPedido(
      parseInt(clienteId),
      predicaoPedidoRequestDTO
    )
    if ('message' in result) {
      toast.error(result.message)
      enviandoRef.current = false
      setIsEnviando(false)
      return
    }

    // Feedback fiel por canal: separa o que foi solicitado entre enviado e falho.
    const enviados: string[] = []
    const falhas: string[] = []
    if (result.emailSolicitado) {
      ;(result.emailEnviado ? enviados : falhas).push('e-mail')
    }
    if (result.whatsappSolicitado) {
      ;(result.whatsappEnviado ? enviados : falhas).push('WhatsApp')
    }

    if (enviados.length === 0) {
      // Nada saiu: se houve canal solicitado, aponta a falha; senao, mensagem generica
      // (caso-limite — o botao e o backend ja exigem ao menos um canal).
      toast.error(
        falhas.length > 0
          ? `Não foi possível enviar por ${falhas.join(' e ')}.`
          : 'Não foi possível enviar o pedido.'
      )
      enviandoRef.current = false
      setIsEnviando(false)
      return
    }

    if (falhas.length > 0) {
      toast.warning(
        `Pedido enviado por ${enviados.join(
          ' e '
        )}, mas falhou por ${falhas.join(' e ')}.`
      )
    } else {
      toast.success(`Pedido enviado por ${enviados.join(' e ')}.`)
    }
    // Mantem o botao desabilitado ate o reload (sucesso recarrega a pagina).
    const timer = setTimeout(() => {
      window.location.reload()
    }, 1500)
    return () => clearTimeout(timer)
  }

  // Recalcula a tabela para o novo "Dias" e registra qual valor passou a valer.
  const aplicarDias = async () => {
    await getBuscaProdutosPedido()
    setDiasAplicados(dias)
  }

  // Gera e baixa o PDF do pedido MONTADO NA TELA (dias do calculo + tabela de quantidades).
  // Envia a mesma lista que o "Enviar" mandaria, por isso o documento nunca contradiz o pedido.
  const gerarPdf = async () => {
    if (isGerandoPdf) return

    const itens = Array.isArray(produtosAdicionados) ? produtosAdicionados : []
    const itensValidos = itens.filter(item => item.quantidade > 0)
    if (itensValidos.length === 0) {
      toast.warning(
        'Adicione ao menos um produto com quantidade maior que zero.'
      )
      return
    }

    if (dias !== diasAplicados) {
      toast.warning(
        'Clique em "Aplicar" para recalcular as quantidades antes de gerar o PDF.'
      )
      return
    }

    const numeroDias = parseInt(diasAplicados)
    if (!numeroDias || numeroDias <= 0) {
      toast.warning('Informe a quantidade de dias.')
      return
    }

    setIsGerandoPdf(true)
    const result = await gerarPedidoPdf(parseInt(clienteId), {
      numeroDias,
      produtos: itensValidos.map(item => ({
        id: item.id,
        quantidade: item.quantidade,
      })),
      oportunidades: oportunidadesAdicionadas.map(item => ({
        id: item.id,
        quantidade: item.quantidade,
        categoria: item.categoria,
      })),
    })
    setIsGerandoPdf(false)

    if (result instanceof Blob) {
      const nomeCliente = clientData?.nome?.trim() || 'cliente'
      saveAs(result, `pedido-${nomeCliente.replace(/[\\/:*?"<>|]+/g, '_')}.pdf`)
      return
    }
    toast.error(result.message)
  }

  const handleQuantidadeChange = (id: number, value: string) => {
    setProdutosAdicionados(prev =>
      prev?.map(item =>
        item.id === id ? { ...item, quantidade: parseInt(value) } : item
      )
    )
  }

  const handleShowProduto = () => {
    setShowProducts(!showProducts)
  }
  const handleKeyClosed = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      showProducts ? setShowProducts(!showProducts) : ''
    }
  }

  const handleShowCancelar = () => {
    setCancelar(!cancelar)
  }

  const handleCheckboxChange = (change: string) => {
    if (change === 'whatsApp') {
      setCheckedWhatsApp(!checkedWhatsApp)
      checkedWhatsApp !== true
        ? setWhasApp(clientData?.whatsapp)
        : setWhasApp('')
    }
    if (change === 'email') {
      setCheckedEmail(!checkedEmail)
      checkedEmail !== true ? setEmail(clientData?.email) : setEmail('')
    }
  }
  useEffect(() => {
    const carregou = instancia && Object.keys(instancia).length > 0
    if (carregou) {
      setIsInstanciaCarregada(true)
    }
  }, [instancia])

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchGetInstancia()
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    const idCliente = localStorage.getItem('idCliente')
    if (idCliente) {
      setClienteId(JSON.parse(idCliente))
    }
  }, [])

  useEffect(() => {
    if (produtos && produtos.length > 0) {
      setProdutosAdicionados(produtos)
    }
  }, [produtos])

  // Carrega as categorias recomendadas do cliente (SEGMENTO, o padrao do Mix) para o seletor de
  // oportunidades. A mesma categoria pode chegar por mais de um segmento; o seletor de-duplica.
  useEffect(() => {
    const buscar = async () => {
      if (!clienteId) return
      const result = await getMixRecomendacoes(parseInt(clienteId), 'SEGMENTO')
      if (Array.isArray(result)) {
        setOportunidadesCategorias(result)
      }
    }
    buscar()
  }, [clienteId])

  const selecionarCategoriaOportunidade = async (categoria: string) => {
    setCategoriaOportunidade(categoria)
    setProdutoOportunidadeId(undefined)
    setProdutosOportunidade([])
    if (!categoria) return
    const result = await getMixProdutos(categoria)
    if (Array.isArray(result)) {
      setProdutosOportunidade(result)
    } else {
      toast.error(result.message)
    }
  }

  const adicionarOportunidade = () => {
    if (!produtoOportunidadeId || quantidadeOportunidade <= 0) {
      toast.warning('Escolha um produto e uma quantidade maior que zero.')
      return
    }
    const produtoEscolhido = produtosOportunidade.find(
      p => p.id === produtoOportunidadeId
    )
    if (!produtoEscolhido) return
    if (oportunidadesAdicionadas.some(o => o.id === produtoEscolhido.id)) {
      toast.info('Esse produto já está nas ofertas.')
      return
    }
    setOportunidadesAdicionadas(prev => [
      ...prev,
      {
        id: produtoEscolhido.id,
        codigoIntegracao: produtoEscolhido.codigoIntegracao,
        nome: produtoEscolhido.nome,
        quantidade: quantidadeOportunidade,
        categoria: categoriaOportunidade,
      },
    ])
    setProdutoOportunidadeId(undefined)
    setQuantidadeOportunidade(1)
  }

  const removerOportunidade = (id: number) => {
    setOportunidadesAdicionadas(prev => prev.filter(o => o.id !== id))
  }

  const handleQuantidadeOportunidade = (id: number, value: string) => {
    setOportunidadesAdicionadas(prev =>
      prev.map(item =>
        item.id === id ? { ...item, quantidade: Number(value) || 0 } : item
      )
    )
  }

  return {
    // subtractDays,
    // data,
    produtos,
    produtosAdicionados,
    setProdutosAdicionados,
    handleQuantidadeChange,
    isLoading,
    setIsLoading,
    isEnviando,
    showProducts,
    setShowProducts,
    handleKeyClosed,
    handleShowProduto,
    valueProduct,
    setValueProduct,
    handleFiltroProduto,
    arrayProdutos,
    produto,
    deletarItem,
    cancelar,
    handleShowCancelar,
    checkedWhatsApp,
    setCheckedWhatsApp,
    checkedEmail,
    setCheckedEmail,
    handleCheckboxChange,
    handleAddProduct,
    valueProductId,
    setValueProductId,
    productArray,
    handleProdutoFiltrado,
    instancia,
    email,
    setEmail,
    whatsApp,
    setWhasApp,
    clientData,
    criaNovoPedido,
    gerarPdf,
    isGerandoPdf,
    aplicarDias,
    dias,
    setDias,
    getBuscaProdutosPedido,
    isInstanciaCarregada,
    // Oportunidades do Mix
    oportunidadesCategorias,
    categoriaOportunidade,
    selecionarCategoriaOportunidade,
    produtosOportunidade,
    produtoOportunidadeId,
    setProdutoOportunidadeId,
    quantidadeOportunidade,
    setQuantidadeOportunidade,
    adicionarOportunidade,
    oportunidadesAdicionadas,
    removerOportunidade,
    handleQuantidadeOportunidade,
  }
}
